import { ClearbitIdentity } from '@clearkit/icons';

export const HomeFooter = () => {
  return (
    <footer className="py-24 border-t border-gray-200">
      <ClearbitIdentity className="m-auto" />
    </footer>
  );
};
